import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { StaticQuery, graphql } from "gatsby";

function SEO({
  description,
  lang,
  meta,
  keywords,
  title,
  url,
  path,
  canonicalUrl,
  googleTagId,
  isTest,
}) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription =
          description || data.site.siteMetadata.description;
        let countryCode;
        switch (lang) {
          case "da":
            countryCode = "da-DK";
            break;
          case "sv":
            countryCode = "sv-SE";
            break;
          case "no":
            countryCode = "no-NO";
            break;
          case "fi":
            countryCode = "fi-FI";
            break;
        }
        return (
          <Helmet
            title={title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
          >
            <link rel="canonical" href={`${canonicalUrl}${path}`} />
            <meta name="description" content={metaDescription} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta
              property="og:image"
              content="http://www.rockwool.dk/dam.papirfly/photos/rw-gmc/20170912_gmc_pho_3"
            />
            <meta property="fb:app_id" content="" />
            <meta name="twitter:card" content="summary" />
            <meta
              name="twitter:creator"
              content={data.site.siteMetadata.author}
            />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={metaDescription} />
            {isTest ? <meta name="robots" content="noindex" /> : ""}
            <html lang={countryCode} />
            {googleTagId
              ? googleTagId.map((tag) => (
                  <script key={tag}>{`
                  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${tag}');
              `}</script>
                ))
              : ""}
          </Helmet>
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: `da`,
  meta: [],
  keywords: [],
  title: "ROCKINFO",
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  url: PropTypes.string,
  path: PropTypes.string,
  canonicalUrl: PropTypes.string,
  googleTagId: PropTypes.array,
  isTest: PropTypes.bool,
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`;
